import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeletePraiseMutationVariables = Types.Exact<{
  input: Types.DeletePraiseInput;
}>;


export type DeletePraiseMutation = { deletePraise?: { success?: boolean | null } | null };


export const DeletePraiseDocument = /*#__PURE__*/ gql`
    mutation deletePraise($input: DeletePraiseInput!) {
  deletePraise(data: $input) {
    success
  }
}
    `;

export function useDeletePraiseMutation() {
  return Urql.useMutation<DeletePraiseMutation, DeletePraiseMutationVariables>(DeletePraiseDocument);
};